export enum IntercomCustomAttributeKey {
    AppName = 'Digiloop app name',
    StoreDomain = 'Store Domain',
    Uninstalled = 'Uninstalled',
    SubscriptionPlanName = 'Subscription plan name',
    Subscription = 'Subscription',
    Trial = 'Trial',
    ShopifyPlan = 'Shopify plan',
    Providers = 'Providers',
    HomeDelivery = 'Home delivery',
    PickupPoint = 'Pickup point',
    ThirdPartyFulfillment = 'Fulfillment service',
}

export enum IntercomOnboardingStepAttributeKey {
    Provider = 'onboarding_step_provider',
    ShippingZone = 'onboarding_step_shipping_zone',
    Integration = 'onboarding_step_integration',
    AppEmbeds = 'onboarding_step_app_embeds',
    Subscribe = 'onboarding_step_subscribe',
}
